import { render, staticRenderFns } from "./teamEvaluation.vue?vue&type=template&id=226b82b7&scoped=true"
import script from "./teamEvaluation.vue?vue&type=script&lang=js"
export * from "./teamEvaluation.vue?vue&type=script&lang=js"
import style0 from "./teamEvaluation.vue?vue&type=style&index=0&id=226b82b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b82b7",
  null
  
)

export default component.exports